export const dashboard = {
	computed: {
		userIsSubscribed () {
			return this.user && this.user.isSubscribed()
		},

		userName () {
			if (!this.user.firstname) return ''
			return ' ' + this.user.firstname
		},

		noOrder () {
			return !this.user.order || !this.user.order.is_ok
		},

		orderHasExtra () {
			return this.user.order && this.user.order.extras.length > 0
		},

		activeOrder () {
			return !this.noOrder && !this.user.order.is_unpaid && !this.suspendedOrSkipped
		},

		unpaidOrder () {
			return !this.noOrder && this.user.order.is_unpaid && !this.suspendedOrSkipped
		},

		skippedOrder () {
			return !this.noOrder && this.user.order.is_skip
		},

		suspendedAbo () {
			return !this.noOrder && this.user.subscription.is_suspended
		},

		suspendedOrSkipped () {
			return this.skippedOrder || this.suspendedAbo
		},

		noOrderButNotSuspended () {
			return this.noOrder && !((this.user.order && this.user.order.is_skip) || this.user.subscription.is_suspended)
		},

		noOrderButSuspended () {
			return this.noOrder && ((this.user.order && this.user.order.is_skip) || this.user.subscription.is_suspended)
		},

		orderClosed () {
			return this.user.order && this.user.order.closed
		}
	}
}
